import { Switch } from "@/components/ui/switch";
import { priceFor } from "@/lib/pricing";

export default function ExtrasToggles({ addons, selected, onToggle, size }) {
  if (!addons.length) return null;
  const groups = [
    { key: "interior", label: "Interior extras" },
    { key: "exterior", label: "Exterior extras" },
    { key: "", label: "Other extras" },
  ].map((g) => ({ ...g, items: addons.filter((a) => (a.category || "") === g.key) })).filter((g) => g.items.length);

  return (
    <div className="mt-6 rounded-xl border border-white/10 overflow-hidden" data-testid="extras-toggles">
      <div className="px-4 py-3 bg-[#0f1522] border-b border-white/5 font-mono text-[11px] uppercase tracking-[0.2em] text-[#00f0ff]">
        Last chance — add extras to this visit
      </div>
      {groups.map((g) => (
        <div key={g.key || "other"}>
          <div className="px-4 pt-3 pb-1 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{g.label}</div>
          {g.items.map((a) => {
            const on = selected.includes(a.id);
            return (
              <label
                key={a.id}
                className={`flex items-center justify-between gap-4 px-4 py-3 border-b border-white/5 last:border-b-0 cursor-pointer transition ${on ? "bg-[#00f0ff]/5" : "hover:bg-white/[0.02]"}`}
                data-testid={`extra-row-${a.slug}`}
              >
                <div className="min-w-0">
                  <div className="font-display uppercase font-bold text-slate-100 text-sm">{a.name}</div>
                  <div className="text-xs text-slate-400 line-clamp-1">{a.description}</div>
                </div>
                <div className="flex items-center gap-3 shrink-0">
                  <span className={`font-display font-extrabold ${on ? "text-[#00f0ff]" : "text-slate-400"}`}>+${priceFor(a, size).toFixed(0)}</span>
                  <Switch checked={on} onCheckedChange={() => onToggle(a.id)} data-testid={`extra-switch-${a.slug}`} className="data-[state=checked]:bg-[#00f0ff]" />
                </div>
              </label>
            );
          })}
        </div>
      ))}
    </div>
  );
}
